// @flow

import type { NurseDeclinedReasonsState } from "./types";

export const initialState: NurseDeclinedReasonsState = {
  requestsInProgress: 0,
  schema: null,
  list: {
    content: [],
    pagination: {
      pageSize: 0,
      pageNumber: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  current: null,
  configuration: {
    enabled: true,
  },
  modals: {
    showAddModal: false,
    showEditModal: false,
    showDiscardModal: false,
    showSubmitModal: false,
    showCancelModal: false,
    showCancelDiscardModal: false,
    showDisableModal: false,
  },
  isLoading: false,
};

export default initialState;
